var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M0.5 8.53651C1.53813 7.43544 2.94756 6.75873 4.5 6.75873C6.05244 6.75873 7.46187 7.43544 8.5 8.53651M6.5 2.98096C6.5 4.08553 5.60457 4.98096 4.5 4.98096C3.39543 4.98096 2.5 4.08553 2.5 2.98096C2.5 1.87639 3.39543 0.980957 4.5 0.980957C5.60457 0.980957 6.5 1.87639 6.5 2.98096Z",
    stroke: "#505050",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.977efabf3f7f24758fbed06b385c31b6.svg";
export { ForwardRef as ReactComponent };